import { setIsLoading } from '../../../../actions/general';
import { callApi } from '../../../../apiCaller';
import { API_SUBSCRIBER_ORGANIZATION_PRODUCT } from '../../../../constants';
import { toastError } from '../../../../utils';

export const SET_ORGANIZATION_COURSES = 'setOrganizationCourses';

export const setOrganizationCourses = (organizationCourses) => {
     return {
          type: SET_ORGANIZATION_COURSES,
          payload: organizationCourses,
     };
};

export const fetchOrganizationCoursesRequest = (organizationId) => async (dispatch) => {
     dispatch(setIsLoading(true));
     return await callApi(API_SUBSCRIBER_ORGANIZATION_PRODUCT.replace(':id', organizationId), 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(setOrganizationCourses(response.data));
               return response.data;
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};
